'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isCustomer as getIsCustomer } from '../utils/utils';
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import UISimpleAvatar from 'ui-addon-avatars/UISimpleAvatar';
import UIUnauthedHubSpotUserAvatar from 'ui-addon-avatars/UIUnauthedHubSpotUserAvatar';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import Small from 'UIComponents/elements/Small';
var AVATAR_SIZE = 'md';

var ReviewerInfo = /*#__PURE__*/function (_PureComponent) {
  _inherits(ReviewerInfo, _PureComponent);

  function ReviewerInfo() {
    _classCallCheck(this, ReviewerInfo);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReviewerInfo).apply(this, arguments));
  }

  _createClass(ReviewerInfo, [{
    key: "renderAvatar",
    value: function renderAvatar(userAvatarUrl, userEmail, isCustomer) {
      if (userAvatarUrl) {
        return React.createElement(UISimpleAvatar, {
          size: AVATAR_SIZE,
          src: userAvatarUrl
        });
      }

      if (isCustomer) {
        return React.createElement(UIAvatar, {
          lookup: {
            type: 'hubSpotUserEmail',
            primaryIdentifier: userEmail
          },
          size: AVATAR_SIZE
        });
      }

      return React.createElement(UIUnauthedHubSpotUserAvatar, {
        email: userEmail,
        size: AVATAR_SIZE
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          company = _this$props.company,
          isCustomer = _this$props.isCustomer,
          userAvatarUrl = _this$props.userAvatarUrl,
          userEmail = _this$props.userEmail,
          userFullName = _this$props.userFullName;
      return React.createElement(UIMediaObject, {
        align: "center",
        itemLeft: this.renderAvatar(userAvatarUrl, userEmail, isCustomer)
      }, React.createElement("p", {
        className: "m-bottom-0"
      }, userFullName), company && React.createElement(Small, {
        className: "m-bottom-0 m-top-1 secondary-text",
        tagName: "p"
      }, company));
    }
  }]);

  return ReviewerInfo;
}(PureComponent);

ReviewerInfo.propTypes = {
  company: PropTypes.string,
  isCustomer: PropTypes.bool.isRequired,
  userAvatarUrl: PropTypes.string,
  userEmail: PropTypes.string,
  userFullName: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  return {
    isCustomer: getIsCustomer(state.auth.portal)
  };
}

var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(ReviewerInfo);